import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function NotFound() {
  const { t } = useTranslation("common");

  return (
    <div className="min-h-screen bg-[#FFFBF7] flex items-center justify-center px-4">
      <div className="text-center max-w-md">
        <div className="w-24 h-24 rounded-full bg-primary-400/10 flex items-center justify-center mx-auto mb-6">
          <i className="ri-compass-discover-line text-primary-400 text-4xl" />
        </div>
        <h1 className="text-4xl md:text-5xl font-bold text-navy-400 mb-2">404</h1>
        <h2 className="text-xl md:text-2xl font-semibold text-gray-700 mb-3">
          {t("pageNotFound")}
        </h2>
        <p className="text-sm md:text-base text-gray-500 mb-8 leading-relaxed">
          {t("pageNotFoundDesc")}
        </p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-8 py-3 bg-primary-400 hover:bg-primary-500 text-white rounded-full font-semibold text-base transition-all hover:scale-105"
        >
          <i className="ri-home-4-line" />
          {t("backToHome")}
        </Link>
      </div>
    </div>
  );
}
